const Header = ({title}) => {
    return (
      <div className="title-container">     
         <h1 className={"text"}>{title}</h1>
      </div>   
    );
  }
  
  export default Header;